import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@/context/AuthContext.jsx";
import { useMarcelMode } from "@/context/MarcelMode.jsx";
import { AppLayout } from "@/layout/AppLayout.jsx";
import { AdminPage } from "@/pages/AdminPage.jsx";
import { DocumentsPage } from "@/pages/DocumentsPage.jsx";
import { ExpensesPage } from "@/pages/ExpensesPage.jsx";
import { GearPage } from "@/pages/GearPage.jsx";
import { GroupPage } from "@/pages/GroupPage.jsx";
import { HistoryPage } from "@/pages/HistoryPage.jsx";
import { LoginPage } from "@/pages/LoginPage.jsx";
import { MemberPage } from "@/pages/MemberPage.jsx";
import { MessagesPage } from "@/pages/MessagesPage.jsx";
import { MorePage } from "@/pages/MorePage.jsx";
import { NotFoundPage } from "@/pages/NotFoundPage.jsx";
import { NotificationsPage } from "@/pages/NotificationsPage.jsx";
import { ObservationPage } from "@/pages/ObservationPage.jsx";
import { PhotosPage } from "@/pages/PhotosPage.jsx";
import { SearchPage } from "@/pages/SearchPage.jsx";
import { SettingsPage } from "@/pages/SettingsPage.jsx";
import { TasksPage } from "@/pages/TasksPage.jsx";
import { MapFullPage } from "@/pages/MapFullPage.jsx";
import { Hunt2026Page } from "@/pages/Hunt2026Page.jsx";
import { ProspectionPage } from "@/pages/ProspectionPage.jsx";
import { SouvenirsPage } from "@/pages/SouvenirsPage.jsx";
import { TodayPage } from "@/pages/TodayPage.jsx";
import { TripsPage } from "@/pages/TripsPage.jsx";
import { LodgingPage } from "@/pages/LodgingPage.jsx";
import { PreparationPage } from "@/pages/PreparationPage.jsx";
import { NordQuestPage } from "@/pages/NordQuestPage.jsx";
import { MyStuffPage } from "@/pages/MyStuffPage.jsx";
import { MenuPage } from "@/pages/MenuPage.jsx";
import { KnowBeforePage } from "@/pages/KnowBeforePage.jsx";
import { VehiclesPage } from "@/pages/VehiclesPage.jsx";

function RequireAuth({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/connexion" replace />;
  return children;
}

function RequireAdmin({ children }) {
  const { isAuthenticated } = useAuth();
  const { actingAsAdmin } = useMarcelMode();
  if (!isAuthenticated) return <Navigate to="/connexion" replace />;
  if (!actingAsAdmin) return <Navigate to="/aujourdhui" replace />;
  return children;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/connexion" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<TodayPage />} />
        <Route path="/aujourdhui" element={<TodayPage />} />
        <Route path="/chasse-2026" element={<Hunt2026Page />} />
        <Route path="/chasse-2026/prospection" element={<ProspectionPage />} />
        <Route path="/chasse-2026/souvenirs" element={<SouvenirsPage />} />
        <Route path="/territoire" element={<MapFullPage />} />
        <Route path="/territoire/carte" element={<MapFullPage />} />
        <Route path="/photos" element={<PhotosPage />} />
        <Route path="/sejour" element={<Navigate to="/chasse-2026/prospection" replace />} />
        <Route path="/sejours" element={<TripsPage />} />
        <Route path="/hebergement" element={<LodgingPage />} />
        <Route path="/preparation/nordquest" element={<NordQuestPage />} />
        <Route path="/preparation" element={<PreparationPage />} />
        <Route path="/sejours/:tripId/preparation" element={<PreparationPage />} />
        <Route path="/mes-affaires" element={<MyStuffPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/a-savoir" element={<KnowBeforePage />} />
        <Route path="/vehicules" element={<VehiclesPage />} />
        <Route path="/groupe" element={<GroupPage />} />
        <Route path="/plus" element={<MorePage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/depenses" element={<ExpensesPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/historique" element={<HistoryPage />} />
        <Route path="/parametres" element={<SettingsPage />} />
        <Route path="/observations" element={<ObservationPage />} />
        <Route path="/taches" element={<TasksPage />} />
        <Route path="/materiel" element={<GearPage />} />
        <Route path="/recherche" element={<SearchPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/admin" element={<RequireAdmin><AdminPage /></RequireAdmin>} />
        <Route path="/admin/reconstruction" element={<RequireAdmin><AdminPage /></RequireAdmin>} />
        <Route path="/membres/:memberId" element={<MemberPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
